<template>
<div>
<div class="messages-block block messages bg-dark p-0 m-0 mb-1">
<a href="javascript:void(0)" class="message d-flex align-items-center">
<div class="content">
  <strong class="d-block">{{ item.cariad }}</strong>
  <span class="d-block">
    <strong>{{ item.barkod}} {{ item.alias}} {{ item.model}}</strong>
  </span>
</div>
</a>
</div>
</div>
</template>

<script>
export default {
  props: {
    item: { required: true }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/servis/TplItem.vue